var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-pagination',{attrs:{"show-size-changer":"","show-total":(total) => `共 ${total} 条数据`,"current":Number(_vm.pageNo),"total":Number(_vm.total),"page-size":Number(_vm.pageSize),"show-quick-jumper":""},on:{"showSizeChange":_vm.pageSizeChange,"change":_vm.pageChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }